import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Block } from "../block.js";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class PageRule extends Rule {
    static of(selector, declarations) {
        return new PageRule(selector, Array.from(declarations));
    }
    _selector;
    _style;
    constructor(selector, declarations) {
        super("page");
        this._selector = selector;
        this._style = Block.of(declarations.filter((declaration) => declaration._attachParent(this)));
    }
    get selector() {
        return this._selector;
    }
    get style() {
        return this._style;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            selector: this._selector,
            style: this._style.toJSON(),
        };
    }
    toString() {
        const style = this._style.toString();
        return `@page ${this._selector} {${style === "" ? "" : `\n${String.indent(style)}\n`}}`;
    }
}
/**
 * @public
 */
(function (PageRule) {
    function isPageRule(value) {
        return value instanceof PageRule;
    }
    PageRule.isPageRule = isPageRule;
    /**
     * @internal
     */
    function fromPageRule(json) {
        return Trampoline.done(PageRule.of(json.selector, Block.from(json.style)));
    }
    PageRule.fromPageRule = fromPageRule;
})(PageRule || (PageRule = {}));
//# sourceMappingURL=page.js.map